import { callAPIWhiteToken } from "../config/api";

const PATH_API = process.env.REACT_APP_API;


export async function postData(data: any) {
    const url = `${PATH_API}/users-sosial-media`;
    return await callAPIWhiteToken({
        url,
        method: "POST",
        data: data
    });
}


export async function getDataSosial() {
    const url = `${PATH_API}/users-sosial-media/list`;
    return await callAPIWhiteToken({
        url,
        method: "GET"
    });
}
